import { render, staticRenderFns } from "./detail_demo.vue?vue&type=template&id=8d129240&scoped=true&"
import script from "./detail_demo.vue?vue&type=script&lang=js&"
export * from "./detail_demo.vue?vue&type=script&lang=js&"
import style0 from "./detail_demo.vue?vue&type=style&index=0&id=8d129240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d129240",
  null
  
)

export default component.exports